export function FullScreenLoading() {
  return (
    <div className="background-fullscreen-loading">
      <div className="spinner-border text-primary loading-spin" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};